import React from 'react';
import { Route } from 'react-router-dom';
import { AppsRedirect } from '../AppsRedirect/AppsRedirect';

export const ConditionedRoute = ({ component: Component, condition, alternatePath, ...rest }) => {
  const render = (props) =>
    condition ? <Component {...props} /> : <AppsRedirect to={alternatePath} />;

  return <Route {...rest} render={render} />;
};
